import React, { useEffect, useState } from 'react'
import './credit-form.scss'
import NormalInput from '../../common/inputs/NormalInput'
import { BiLoaderAlt } from 'react-icons/bi'
import { accountingAxios } from '../../../config/axios'
import { toast } from 'react-hot-toast'

function CreditForm({ data, setData, setModal, setTotal }) {
    const [form, setForm] = useState({ cid: '', amount: 0 })
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState(data?.credit_amount || 0)

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
        if (e.target.name === 'amount') {
            setAmount((data?.credit_amount || 0) + Number(e.target.value))
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setLoading(true)
        if (data) {
            accountingAxios.put('/credit-amount', form).then(() => {
                if (amount > 0) {
                    setData((state) => state.map((item) => {
                        if (item.cid === form.cid) {
                            return { ...item, credit_amount: Number(amount) }
                        } else {
                            return item
                        }
                    }))
                } else {
                    setData((state) => state.filter((item) => item.cid !== form.cid))
                }
                setTotal((currentTotal) => Number(currentTotal) + Number(form.amount))
                setModal((state) => ({ ...state, status: false }))
                toast.success('Credit Updated')
                setLoading(false)
            }).catch((error) => {
                toast.error(error.message)
                setLoading(false)
            })
        } else {
            accountingAxios.post('/credit-amount', form).then((response) => {
                setData((state) => [response.data, ...state])
                setTotal((currentTotal) => Number(currentTotal) + Number(amount))
                setModal((state) => ({ ...state, status: false }))
                toast.success('Credit created')
                setLoading(false)
            }).catch((error) => {
                toast.error(error.message)
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        if (data) {
            setForm({
                ...form,
                cid: data.cid
            })
        }
        // eslint-disable-next-line
    }, [data])

    return (
        <div className='credit-form-div'>
            <form action="" onSubmit={handleSubmit}>
                {data && <div className="amount-div">
                    <h4>{String(amount) || data?.credit_amount || 0}</h4>
                    <p>Balance</p>
                </div>}
                {!data && <NormalInput label='Customer ID' type={'number'} name='cid' value={form?.cid || ''} onChangeFun={handleChange} />}
                <NormalInput label={data ? 'Amount (-/+)' : 'Credit'} type={'number'} name='amount' value={form?.amount || ''} onChangeFun={handleChange} />
                <div className="button-div">
                    <button>{loading ? <span className='loading-icon'><BiLoaderAlt /></span> : data ? 'Update' : 'Create'}</button>
                </div>
            </form>
        </div>
    )
}

export default CreditForm